import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BloqueioAgenda, BloqueioAgendaListModel, BloqueioAgendaPostModel } from "app/models/bloqueio-agenda.model";
import { PaginacaoModel, ResultadoPaginado } from "app/models/paginacao.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { environment } from "environments/environment";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class BloqueioAgendaService {
    constructor(private httpClient: HttpClient) { }

    adicionar(model: BloqueioAgendaPostModel): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/BloqueioAgenda/adicionar/`, model)
        );
    }

    atualizar(model: BloqueioAgendaPostModel): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/BloqueioAgenda/atualizar/`, model)
        );
    }

    remover(id: number): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/BloqueioAgenda/remover/${id}`)
        );
    }

    obter(id: number): Promise<BloqueioAgenda> {
        return firstValueFrom(
            this.httpClient.get<BloqueioAgenda>(`${environment.urlApi}/BloqueioAgenda/obter/${id}`)
        );
    }

    obterLista(paginacao: PaginacaoModel): Promise<ResultadoPaginado<BloqueioAgendaListModel>> {
        let params = new HttpParams()
            .set('pagina', paginacao.pagina)
            .set('tamanhoPagina', paginacao.tamanhoPagina)
            .set('ordenarPor', paginacao.ordenarPor)
            .set('descendente', paginacao.descendente);
        if (paginacao.pesquisa) params = params.set('pesquisa', paginacao.pesquisa);
        return firstValueFrom(
            this.httpClient.get<ResultadoPaginado<BloqueioAgendaListModel>>(
                `${environment.urlApi}/BloqueioAgenda/obterLista/`, { params })
        );
    }
}
